export default __webpack_public_path__ + "static/media/Version (2) - LOTR_03.87d733f8.jpg";